var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
import { inject } from "tsyringe";
import { RMutableMultiSet } from "../../collections";
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { ProductInstanceCreatorFactory } from "../ProductInstanceCreator";
import { PurchaseOrderPayload } from "../PurchaseOrderPayload";
import { CrossSellingItemInstanceProductCardBehaviour } from "./CrossSellingItemInstanceBehaviour";
import { CrossSellingItemInstanceFactory } from "./CrossSellingItemInstanceFactory";
import { CrossSellingItemInstanceListService } from "./CrossSellingItemInstanceListService";
import { ICrossSellingListProvider } from "./CrossSellingListProvider";
import { ProductCardCrossSellingCreator } from "./ProductCardCrossSellingCreator";
let ProductCardCrossSellingCreatorFactory = class ProductCardCrossSellingCreatorFactory {
    constructor(productInstanceCreatorFactory, listProvider, purchaseOrderPayload, crossSellingItemInstanceListService) {
        this.productInstanceCreatorFactory = productInstanceCreatorFactory;
        this.listProvider = listProvider;
        this.purchaseOrderPayload = purchaseOrderPayload;
        this.crossSellingItemInstanceListService = crossSellingItemInstanceListService;
        makeImmutable(this);
    }
    create() {
        const crossSellingItemQuantities = RMutableMultiSet.empty();
        const crossSellingItemInstanceFactory = new CrossSellingItemInstanceFactory({
            productInstanceCreatorFactory: this.productInstanceCreatorFactory,
            listProvider: this.listProvider,
            createBehaviour: (crossSellingItemTypeId) => new CrossSellingItemInstanceProductCardBehaviour({
                typeId: crossSellingItemTypeId,
                crossSellingItemQuantities,
            }),
        });
        return new ProductCardCrossSellingCreator({
            crossSellingItemInstanceFactory,
            purchaseOrderPayload: this.purchaseOrderPayload,
            crossSellingItemInstanceListService: this.crossSellingItemInstanceListService,
        });
    }
};
ProductCardCrossSellingCreatorFactory = __decorate([
    perRestaurant(),
    __param(1, inject(ICrossSellingListProvider)),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductInstanceCreatorFactory !== "undefined" && ProductInstanceCreatorFactory) === "function" ? _a : Object, typeof (_b = typeof ICrossSellingListProvider !== "undefined" && ICrossSellingListProvider) === "function" ? _b : Object, typeof (_c = typeof PurchaseOrderPayload !== "undefined" && PurchaseOrderPayload) === "function" ? _c : Object, typeof (_d = typeof CrossSellingItemInstanceListService !== "undefined" && CrossSellingItemInstanceListService) === "function" ? _d : Object])
], ProductCardCrossSellingCreatorFactory);
export { ProductCardCrossSellingCreatorFactory };
